import React, { useContext, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import { AppContext } from "Context/AppContext";
import Avatar from "react-avatar";
import searchIcon from 'assests/img/search-icon.svg';
import HierachicalDropdown from "Components/Common/HierachicalDropdown";
import useSearchBar from "./Components/useSearchBar";
import "styles/main.css";
import SearchBarCreateButton from "./Components/SearchBarCreateButton";
import Select from "Components/GMS/Select";
import DownloadIndicator from "Components/GMS/Rules/Components/DownloadIndicator";
import AppSettings from "Settings/AppSettings";
import AuthManager from "Common/AuthManager";

const Searchbar = (props: {}) => {
  const history = useHistory();
  const appData = useContext<any>(AppContext);

  const {
    partyList,
    handlePartyChange,
    industryList,
    handleIndustryChange,
    getUserName,
    channelList,
    selectedChannel,
    handleChannelChange,
    parentChannelList,
    selectedParentChannel,
    handleParentChannelChange,
    environmentList,
    selectedEnvironment,
    handleEnvironmentChange,
    isLoadingParty,
    isLoadingIndustry,
    isLoadingChannel,
    isLoadingEnvironment,
    refreshEnvironments 
  } = useSearchBar();
  
 
  React.useEffect(() => {
    if (selectedParentChannel && 
        (!environmentList || environmentList.length === 0) && 
        !isLoadingEnvironment) {
      refreshEnvironments(selectedParentChannel.id);
    }
  }, [selectedParentChannel]);

 
  React.useEffect(() => {
    if (environmentList && 
        environmentList.length > 0 && 
        !selectedEnvironment && 
        !isLoadingEnvironment) {
      const firstEnv = environmentList[0];
      handleEnvironmentChange(firstEnv);
    }
  }, [environmentList]);
  
  const handleKeyPress: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === "Enter") {
      const target = event.target as HTMLInputElement;
      history.push("/gms/search/" + encodeURIComponent(target.value));
    }
  };

  const onClickHelpIcon = () => {
    const SAMS_SSO_URL = AppSettings.SAMS_SSO_URL?.split('/landing')[0];
    const SAMS_TOKEN = AuthManager.getSamsToken();
    const url = `${SAMS_SSO_URL}/launchHelpDesk?token=${SAMS_TOKEN}`;
    const newWindow = window.open(url, '_blank', "noopener noreferrer");
    if (newWindow) newWindow.opener = null
  }

  const modalRoot = document.querySelector('#modal-root');

  return (
    <React.Fragment>
      {window.location.pathname && (
       <nav
        id="main-navigation"
        className={`tw-max-w-screen tw-bg-white tw-sticky tw-top-0 tw-left-0 tw-flex tw-items-center tw-flex-wrap md:tw-justify-start md:tw-flex-nowrap tw-m-0`}>
        <div
          id="navigation-container"
          className={`tw-flex tw-flex-nowrap tw-items-center tw-justify-between tw-py-[2px] tw-px-3 tw-pointer-events-auto tw-w-full tw-border tw-shadow-md`}
        >
        <div id="navigation-left-section" className={`tw-flex tw-items-center tw-space-x-8`}>
          <img
            id="logo"
            width="171px"
            height="22px"
            className={`tw-relative tw-m-1 tw-ml-0 tw-h-6`}
            src={process.env.PUBLIC_URL + "/img/Logo-ai.svg"}
            alt="logo"
          />
          <div id="navigation-dropdown-container" className={`tw-h-full`}>
            <div id="navigation-dropdown-wrapper" className={`tw-flex tw-items-center tw-space-x-1.5`}>
              <HierachicalDropdown
                id="workspace-domain-dropdown"
                columnOptions={[
                  { 
                    title: "Workspace", 
                    name: "workspace", 
                    nameColumn: "name", 
                    idColumn: "id", 
                    className: "!tw-text-md tw-text-black !tw-font-extrabold tw-italic tw-pr-1"
                  },
                  { 
                    title: "Domain", 
                    name: "domain", 
                    nameColumn: "name", 
                    idColumn: "id" 
                  },
                  { 
                    title: "Channel", 
                    name: "channel", 
                    nameColumn: "name", 
                    idColumn: "id" 
                  },
                  { 
                    title: "Environment", 
                    name: "environment", 
                    nameColumn: "name", 
                    idColumn: "id" 
                  },
                ]}
                data={[
                  partyList || [], 
                  industryList || [], 
                  parentChannelList || [],
                  environmentList || []
                ]}
                selected={[
                  appData.selectedParty, 
                  appData.selectedIndustry, 
                  selectedParentChannel,
                  selectedEnvironment
                ]}
                onClick={[
                  handlePartyChange, 
                  handleIndustryChange,
                  handleParentChannelChange,
                  handleEnvironmentChange
                ]}
                isLoading={{
                  0: isLoadingParty,
                  1: isLoadingIndustry,
                  2: isLoadingChannel,
                  3: isLoadingEnvironment
                }}
              />
            </div>
          </div>
        </div>
      
        <div id="navigation-right-section" className={`tw-flex tw-space-x-3`}>
          {appData.downloadState.downloadFlag ?  
            <div id="download-indicator-container" className="tw-flex tw-item-center">
              <DownloadIndicator 
                id="download-indicator"
                message={appData?.downloadState?.message ?? ''}/> 
            </div> : null}
          <div id="search-container">
            <div id="search-input-wrapper" className={`tw-flex tw-item-center tw-rounded-md tw-w-min tw-bg-gray tw-border tw-border-gray`}>
              <button
                id="search-icon-button"
                className={`tw-relative tw-block tw-w-9 tw-aspect-square tw-h-full`}
                type="button"
              >
                <img id="search-icon" className={`tw-m-auto`} src={searchIcon} alt="Search Icon" />
              </button>
              <input
                id="search-input"
                type="search"
                className={`tw-30 focus:tw-outline-none
                tw-border-0
                tw-text-xs 
                tw-block 
                tw-py-1 tw-px-3 
                tw-bg-transparent tw-bg-clip-padding
                tw-text-gray-700 focus:tw-text-gray-700  
                tw-rounded-md tw-flex-grow tw-font-normal 
                tw-shadow-none !autofill:tw-bg-gray autofill:tw-shadow-none`}
                placeholder="Search"
                aria-label="Search"
                aria-describedby="basic-addon1"
                autoComplete="off"
                onKeyDown={handleKeyPress}
              />
            </div>
          </div>
      
          <div id="navigation-actions-container" className={`tw-flex tw-grid-cols-4 tw-items-center tw-h-full tw-space-x-3`}>
            <SearchBarCreateButton id="create-button"/>
            <button 
              id="help-button"
              onClick={(e) => { e.stopPropagation(); onClickHelpIcon(); }}
              key={"Help"} 
              className={`tw-text-gray-500 tw-font-noto-sans tw-text-xs tw-font-medium tw-leading-normal tw-p-2`}>
                <span id="help-icon-container">
                    <i id="help-icon" className={`far fa-question-circle tw-text-xl`} aria-hidden="true"/>
                </span>
            </button>
      
            <div id="user-avatar-container" className={`tw-cursor-pointer tw-relative tw-group`}>
              <Avatar
                name={getUserName()}
                size="40"
                round={true}
                // @ts-ignore
                color={Avatar.getRandomColor("sitebase", ["yellow", "#FFD60A"])}
                fgColor="#000000"
              />
      
              <ul
                id="user-dropdown-menu"
                className={`tw-absolute tw-hidden group-hover:tw-block tw-top-full tw-right-0 tw-w-min tw-h-fit tw-bg-white tw-border tw-rounded`}
              >
                <li id="logout-menu-item">
                  <button
                    id="logout-button"
                    className={`tw-py-2.5 tw-pl-4 tw-pr-12 hover:tw-bg-gray`}
                    onClick={() => {history.replace({pathname: `/logout`});}}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      </nav>
      )}
      {modalRoot ? <iframe
        style={{ display: "none" }}
        src={appData?.downloadUrl}
        onLoad={() => console.log("onLoad")}
        id="iframe_download_cbm"
        title="Download CBM"
      /> : null}
    </React.Fragment>
  );
};

export default Searchbar;